<template>
    <b-modal
        id="new-enps-research"
        size="lg"
        centered
        hide-header
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
    >
        <Form
            @submit="submitHandler"
            @cancel="cancelHandler"
            @apply-and-create="onCreateAndApply"
            researchTitle="enps.newEnpsResearch"
            submitButton="enps.createResearch"
            :isNewResearch="true"
        />
    </b-modal>
</template>
<script>
import Form from '../components/Form'
import enpsMixin from './enpsMixin'

export default {
    name: 'NewEnpsResearch',
    components: {
        Form,
    },
    mixins: [enpsMixin],
    mounted() {
        this.openModal()
    },
    methods: {
        openModal() {
            this.$bvModal.show('new-enps-research')
        },
        onCreateAndApply(data) {
            this.onSubmit(
                null,
                data,
                'create-apply',
                'research-created',
                'new-enps-research'
            )
        },
        submitHandler(data) {
            this.onSubmit(
                null,
                data,
                'create',
                'research-created',
                'new-enps-research'
            )
        },
        cancelHandler() {
            this.onCancel('new-enps-research')
        },
    },
}
</script>
